(function() {
  'use strict';

  angular.module('component.eventTypes')
    .component('eventTypePredefinedFields', {
      templateUrl: 'app/components/event-types/event-type-section-predefined-fields.html',
      controller: 'EventTypePredefinedFieldsController',
      controllerAs: 'predefinedFieldsCtrl',
      bindings: {
        eventTypeId: '<',
        sectionId: '<'
      }
    });
})();
